import {
  updateOutOfStockItemRemovalEnabled,
  updateBundleOutOfStockAutoPauseEnabled,
  updateInstantDigitalItemFulfillmentEnabled,
  updateBillingRecoveryMethod,
} from "@vendor-app/app/_state/actionCreators/organization";
import { GeneralSmartrrDispatch } from "@vendor-app/app/_state/typedVendorRedux";
import { BillingRecoveryMethodOptionEnum } from "@smartrr/shared/entities/Organization";

export async function handleOutOfStockItemRemovalUpdate(
  outOfStockItemRemovalEnabled: boolean | null | undefined,
  dispatch: GeneralSmartrrDispatch,
  addToast: (content: string, error?: boolean) => void
) {
  if (typeof outOfStockItemRemovalEnabled !== "boolean") {
    addToast("Select a valid out of stock item removal setting");
    return;
  }

  await dispatch(updateOutOfStockItemRemovalEnabled(outOfStockItemRemovalEnabled)).then(res => {
    if (res.type === "UPDATED_OUT_OF_STOCK_ITEM_REMOVAL") {
      addToast("Out of stock item removal setting updated");
    }
  });
}

export async function handleBundleOutOfStockAutoPauseUpdate(
  bundleOutOfStockAutoPauseEnabled: boolean | null | undefined,
  dispatch: GeneralSmartrrDispatch,
  addToast: (content: string, error?: boolean) => void
) {
  if (typeof bundleOutOfStockAutoPauseEnabled !== "boolean") {
    addToast("Select a valid bundle auto-pause setting");
    return;
  }

  await dispatch(updateBundleOutOfStockAutoPauseEnabled(bundleOutOfStockAutoPauseEnabled)).then(res => {
    if (res.type === "UPDATED_BUNDLE_OUT_OF_STOCK_AUTO_PAUSE") {
      addToast("Auto-pause subscriptions on out of stock bundle items setting updated");
    }
  });
}

export async function handleInstantDigitalItemFulfillmentUpdate(
  instantDigitalItemFulfillmentEnabled: boolean | null | undefined,
  dispatch: GeneralSmartrrDispatch,
  addToast: (content: string, error?: boolean) => void
) {
  if (typeof instantDigitalItemFulfillmentEnabled !== "boolean") {
    addToast("Select a valid instant digital item fulfillment setting");
    return;
  }

  await dispatch(updateInstantDigitalItemFulfillmentEnabled(instantDigitalItemFulfillmentEnabled)).then(res => {
    if (res.type === "UPDATED_INSTANT_DIGITAL_ITEM_FULFILLMENT") {
      addToast("Instant digital item fulfillment setting updated");
    }
  });
}

export async function handleBillingRecoveryMethodUpdate(
  billingRecoveryMethod: BillingRecoveryMethodOptionEnum | null | undefined,
  dispatch: GeneralSmartrrDispatch,
  addToast: (content: string, error?: boolean) => void
) {
  if (!billingRecoveryMethod) {
    addToast("Select a valid billing recovery method setting");
    return;
  }

  await dispatch(updateBillingRecoveryMethod(billingRecoveryMethod)).then(res => {
    if (res.type === "UPDATED_BILLING_RECOVERY_METHOD") {
      addToast("Payment recovery method setting updated");
    }
  });
}
